"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* global Quill */
var quill_editor_html_1 = __importDefault(require("./quill-editor.html"));
require("./quill-editor.less");
(function (app) {
    'use strict';
    app.directive('prScheduleEmailQuillEditor', [
        '$filter',
        '$sanitize',
        function ($filter, $sanitize) {
            var quillObject;
            return {
                restrict: 'EA',
                scope: {
                    quillEditor: '='
                },
                templateUrl: quill_editor_html_1.default,
                link: function ($scope, element) {
                    // TODO: Remove eslint-disable-line when font-size, font-family, & text-align are enabled.
                    var translate = $filter('translate'); // eslint-disable-line no-unused-vars
                    // The toolbar html must be appended here so translations work.
                    var toolbarEl = '' +
                        '<div id="schedule-email-text-editor-toolbar">' +
                        // Disabled: font-family is rendered as a class
                        // instead of a style tag and thus does not render correctly in emails.
                        // '<select class="ql-font">' +
                        // 	'<option selected value="sansserif">' + translate('FONT.SANSERIF') + '</option>' +
                        // 	'<option value="serif">' + translate('FONT.SERIF') + '</option>' +
                        // 	'<option value="monospace">' + translate('FONT.MONOSPACE') + '</option>' +
                        // '</select>' +
                        // Disabled: Font-size fails to re-load correctly in Quill.
                        // '<!-- Add font size dropdown -->' +
                        // '<select class="ql-size">' +
                        // 	'<option selected value="12px">' + translate('SMALL') + '</option>' +
                        // 	'<option value="16px">' + translate('MEDIUM') + '</option>' +
                        // 	'<option value="20px">' + translate('LARGE') + '</option>' +
                        // '</select>' +
                        '<!-- Add a font-style buttons -->' +
                        '<button class="ql-bold"></button>' +
                        '<button class="ql-italic"></button>' +
                        '<button class="ql-underline"></button>' +
                        '<!-- Add ordered and bullet list buttons -->' +
                        '<button class="ql-list" value="ordered"></button>' +
                        '<button class="ql-list" value="bullet"></button>' +
                        // Disabled: text-align is rendered as a class
                        // instead of a style tag and thus does not render correctly in emails.
                        // '<!-- Add text-align dropdown -->' +
                        // '<select class="ql-align">' +
                        // '</select>' +
                        '<!-- Add remove formatting button -->' +
                        '<button class="ql-clean"></button>' +
                        '</div>';
                    element.prepend(toolbarEl);
                    quillObject = new Quill('#schedule-email-text-editor', {
                        modules: {
                            toolbar: '#schedule-email-text-editor-toolbar'
                        },
                        theme: 'snow'
                    });
                    quillObject.setText('');
                    // Mimic the blue glow that inputs and buttons have when activated.
                    quillObject.on('selection-change', function (range) {
                        var textEditorParent = element.closest('.schedule-email-message');
                        if (range) { // focus
                            textEditorParent.addClass('active');
                        }
                        else { // blur
                            textEditorParent.removeClass('active');
                        }
                    });
                    $scope.quillEditor = {
                        getHtml: function () {
                            return $sanitize(quillObject.root.innerHTML);
                        },
                        setHtml: function (html) {
                            var quillDelta = quillObject.clipboard.convert($sanitize(html));
                            quillObject.setContents(quillDelta);
                        }
                    };
                }
            };
        }
    ]);
})(angular.module('qualtrics.pr'));
